import { Typography} from "@mui/material";
import Image from "next/image";
import picIcon from "../../../public/images/profilePic.png";
import { useEffect, useState } from "react";
import { changePicture } from "./changePicture";





export const UserSection = ({
  userData, 
}) => {
  
  const [selectedImage, setSelectedImage] = useState("/");


  useEffect(() => {
    if (userData.store_image != null && userData.store_image != undefined) {
      setSelectedImage(userData.store_image);
    }
    else {
      setSelectedImage(picIcon);
    }

    document?.getElementById("upload_image")?.addEventListener(
      "click",
      function () {
        //@ts-ignore
        //event.preventDefault();
        openWidget();
      },
      false,
    );
}, [userData]);

const openWidget = async () => {
  let myWidget = window?.cloudinary?.createUploadWidget(
    {
      cloudName: "dkceblkn7",
      upload_preset: "gfb8o5ca",
      defaultSource: "local",
      sources: ["local", "camera", "google_drive", "dropbox"],
      multiple: false,
      styles: {
        palette: {
          window: "#DDCDC5",
          windowBorder: "#BC7F7C",
          tabIcon: "#67605F",
          menuIcons: "#4D4D33",
          textDark: "#000000",
          textLight: "#FFFFFF",
          link: "#4D4D33",
          action: "#FF620C",
          inactiveTabIcon: "#ABB2B2",
          error: "#FF3636",
          inProgress: "#3DB2FF",
          complete: "#9DF2B0",
          sourceBg: "#FAFCFC",
        },
        fonts: {
          default: null,
          // "'Fira Sans', sans-serif": {
          //   url: "https://fonts.googleapis.com/css?family=Fira+Sans",
          //   active: true,
          // },
          "Montserrat, sans-serif": {
            url: "https://fonts.googleapis.com/css2?family=Montserrat",
            active: true,
          },
        },
      },
    },
    //@ts-ignore
    (error, result) => {
      //console.log(error);
      if (result.event == "success") {
        //@ts-ignore
        //console.log(result.info)
        setSelectedImage(result.info.secure_url);
        const data = {
          store_id: userData.store_id,
          new_picture: result.info.secure_url,
        };
        try {
          changePicture(data);
        } catch (error) {
          alert("Error uploading image. Please try again.");
        }
      }
    },
  );

  myWidget.open();
};
  
 return (
    <div className="dashboard__content__component" style={{maxWidth:"200px"}}>   
        <div className="dashboard__content__image" style={{overlay:"auto"}}>
          <Image
                src={selectedImage}
                width={165}
                height={165}
                objectFit="cover"
                alt="Store Picture"
                id="upload_image"
            />
        </div>  
        <div style={{paddingTop:"5px", textAlign:"center"}}>
            <Typography fontSize={20} fontWeight={700}>{userData?.store_name}</Typography>
        </div>
        <Typography>{userData?.store_description}</Typography>
    </div>
  );
};

export default UserSection;
